import { useState, useEffect, useCallback } from 'react'
import { toast } from 'react-toastify'
import { useApi } from 'hooks/useApi'
import { useIntake } from 'hooks/useIntakeContext'
import { useFormDebounce } from 'hooks/useFormDebounce'

export const useQuilttIntegration = (onAccountsUpdated, onClose) => {
  const { intakeState, updateIntakeStateAtKey } = useIntake()
  const { updateIntakeStateAndSubmit } = useFormDebounce()
  const { apiRequest } = useApi()

  const updateQuiltt = useCallback(
    async (quilttUserId, sessionToken) => {
      // console.log('update quiltt running')
      try {
        await apiRequest('/api/quiltt/quilttSession', {
          method: 'POST',
          body: JSON.stringify({ quilttUserId, sessionToken }),
        })
        onAccountsUpdated?.()
      } catch (e) {
        console.error('Error updating Quiltt:', e)
      }
    },
    [apiRequest, onAccountsUpdated]
  )

  const updateUserWithQuilttId = useCallback(
    (quilttUserId) => {
      updateIntakeStateAndSubmit(() => {
        return updateIntakeStateAtKey({ quilttUserId })
      })()
    },
    [updateIntakeStateAndSubmit, updateIntakeStateAtKey]
  )

  const refreshQuiltt = useCallback(() => {
    // console.log('refreshing quiltt')
    // console.log('quilttUserId', intakeState?.quilttUserId)
    // console.log('quilttSessionToken', intakeState?.quilttSessionToken)
    updateQuiltt(intakeState?.quilttUserId, intakeState?.quilttSessionToken)
    toast.success(
      'Fetching updated account balances with Quiltt! They will appear in your balance sheet momentarily',
      {
        position: 'top-center',
        autoClose: 8000,
        pauseOnFocusLoss: false,
        pauseOnHover: false,
      }
    )
  }, [intakeState?.quilttUserId, intakeState?.quilttSessionToken, updateQuiltt])

  const handleExitSuccess = useCallback(
    (metadata) => {
      try {
        console.log(metadata)
        const profileId = metadata.profileId

        setTimeout(
          () => updateQuiltt(profileId, intakeState?.quilttSessionToken),
          5000
        )

        if (
          !intakeState?.quilttUserId ||
          intakeState?.quilttUserId !== profileId
        ) {
          updateUserWithQuilttId(profileId)
        }

        toast.success(
          'You have successfully added your accounts with Quiltt! They will appear in your balance sheet momentarily',
          {
            position: 'top-center',
            autoClose: 8000,
            pauseOnFocusLoss: false,
            pauseOnHover: false,
          }
        )
        // if onClose is available close the modal
        if (typeof onClose === 'function') {
          console.log('Closing modal after Quiltt success...')
          onClose()
        }
      } catch (err) {
        console.error('Error in handleExitSuccess:', err)
      }
    },
    [
      intakeState?.quilttUserId,
      intakeState?.quilttSessionToken,
      updateQuiltt,
      updateUserWithQuilttId,
      onClose,
    ]
  )

  // useEffect(() => {
  //   if (intakeState?.quilttUserId && intakeState?.quilttSessionToken) {
  //     updateQuiltt(intakeState.quilttUserId, intakeState.quilttSessionToken)
  //   }
  // }, [intakeState?.quilttUserId, intakeState?.quilttSessionToken, updateQuiltt])

  const unlinkQuilttConnection = useCallback(
    async ({ sessionToken, connectionId }) => {
      try {
        const response = await apiRequest(
          '/api/quiltt/quilttUnlinkConnection',
          {
            method: 'POST',
            body: JSON.stringify({ sessionToken, connectionId }),
          }
        )
        console.log('Unlink Response:', response)
        return response
      } catch (e) {
        console.error(e)
      }
    },
    [apiRequest]
  )

  return {
    refreshQuiltt,
    handleExitSuccess,
    unlinkQuilttConnection,
  }
}
